import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Music from "./pages/Music"; // 👈 Import Music page
import Booking from "./pages/Booking";
import GalleryPage from "./pages/GalleryPage";
import "leaflet/dist/leaflet.css";
// import About from './pages/About';
// import Tour from './pages/Tour';
import Contact from "./pages/Contact";

function App() {
  return (
    <Router>
      <Routes>
        {/* The Home page has its own built-in header and no footer */}
        <Route path="/" element={<Home />} />

        {/* The Music page uses the standard Header and Footer */}
        <Route
          path="/music"
          element={
            <>
              <Header />
              <Music />
              <Footer />
            </>
          }
        />

        {/* Add other routes here following the same pattern */}
        <Route
          path="/contact"
          element={
            <>
              <Header />
              <Contact />
              <Footer />
            </>
          }
        />
        <Route
          path="/gallery/:slug"
          element={
            <>
              <Header />
              <GalleryPage />
              <Footer />
            </>
          }
        />
        <Route
          path="/booking"
          element={
            <>
              <Header />
              <Booking />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
